import template from "./template_crud";
const path = '/receipt/material'
export const getMaterials  = template.getList(path)
export const getMaterialsById  = template.getById(path)
export const addMaterials = template.addOne(path)
export const deleteMaterials = template.deleteById(path)